import { RioCategory } from '@backoffice-frontend/graphql'
import { useHasRioWriteRights } from '../../utils'

// the enum structure is "<Origin in the backoffice><Operation (optional)>"
export enum CreationContext {
  SafetyDriverGuidance = 'SafetyDriverGuidance',
  VehicleInteractionServiceCancellation = 'VehicleInteractionServiceCancellation',
  FleetMapServiceCancellation = 'FleetMapServiceCancellation',
  FleetMapDocumentProblem = 'FleetMapDocumentProblem',
  FleetMapTurnPoolingOff = 'FleetMapTurnPoolingOff',
}

export const getCategoriesForCreationContext = (
  creationContext: CreationContext,
): RioCategory[] => {
  const ReportCategories = (() => {
    switch (creationContext) {
      case CreationContext.SafetyDriverGuidance:
        return [
          RioCategory.DamageReport,
          RioCategory.VehicleChecks,
          RioCategory.Disruption,
        ]
      case CreationContext.VehicleInteractionServiceCancellation:
        return [RioCategory.Accident, RioCategory.Disruption]
      case CreationContext.FleetMapServiceCancellation:
        return [RioCategory.Accident, RioCategory.Disruption]
      case CreationContext.FleetMapDocumentProblem:
        return [RioCategory.Accident, RioCategory.Disruption]
      case CreationContext.FleetMapTurnPoolingOff:
        return [RioCategory.Accident, RioCategory.Disruption]
      default:
        return []
    }
  })()
  return ReportCategories.filter((category: RioCategory) =>
    useHasRioWriteRights(category),
  )
}
